import React, { useEffect, useState } from 'react';
// Material UI :
import { Box, Modal } from '@mui/material';
// Toast :
import { toast } from 'sonner';
// import 'react-toastify/dist/ReactToastify.css';
// Functions :
import { createResponosable } from '../../config/responsablesConfig';
import { getGroups } from '../../config/groups';
// Assets : 
import Loading from '../../assets/images/white-loading.gif';
// React-select :
import Select from 'react-select';

export const AddRespoModal = ({ onAdd }) => {
    const [respoName, setRespoName] = useState('');
    const [respoGroup, setRespoGroup] = useState('');
    const [respoEmail, setRespoEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [groups, setGroups] = useState([]);

    // ? ===============================|| Modal Style ||===============================
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [width, setWidth] = useState('50%');
    const [padding, setPadding] = useState(3);

    const currentWidth = window.innerWidth;

    useEffect(() => {
        if (currentWidth <= 500) {
            setWidth('90%');
            setPadding(2);
        }
    }, [currentWidth]);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: width,
        maxHeight: '95vh',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: padding,
        borderRadius: 3
    };
    // ? ===============================================================================

    // ? ===============================|| Toast ||===============================
    // const notifySuccess = (message) => toast.success(message, {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    // });
    // const notifyError = (message) => toast.error(message, {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    // });
    // const notifyInfo = (message) => toast.info(message, {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    // });
    // ? ===============================================================================

    // ? =============================|| Add Responsable ||=============================
    const handleAddResponsable = async () => {
        try {
            setIsLoading(true);
            if (respoName !== '' && respoGroup !== '' && respoEmail !== '') {
                const result = await createResponosable(respoName, respoEmail, respoGroup);
                if (result === 'Created') {
                    onAdd(); // Refresh table after adding an affair.
                    // notifySuccess('Responsable ajouté avec succès');
                    toast.success('Responsable ajouté avec succès');
                    handleClose();
                    setRespoName('')
                    setRespoGroup('');
                    setRespoEmail('');
                    setIsLoading(false);
                } else if (result === 'Exist') {
                    // notifyInfo('l\'email existe déjà, veuillez réessayer');
                    toast.info('l\'email existe déjà, veuillez réessayer')
                    handleClose();
                }
            } else {
                setIsLoading(false);
                // handleClose();
                // notifyInfo('Veuillez remplir toutes les informations du formulaire !');
                toast.info('Veuillez remplir toutes les informations du formulaire !')
            }
        } catch (error) {
            setIsLoading(true);
            // notifyError();
            toast.warning('Il y a un problème, veuillez réessayer !')
            handleClose();
            setIsLoading(false);
        }
    };
    // ? ===============================================================================

    // ? ============================|| Handle Enter Click ||===========================
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleAddResponsable();
        }
    };
    // ? ===============================================================================

    // ? ==============================|| get Group Name ||=============================
    useEffect(() => {
        const handleGetGroups = async () => {
            const result = await getGroups();
            setGroups(result);
        };

        handleGetGroups();
    }, []);
    // ? ==============================================================================

    return (
        <div>
            <button
                className='border border-primary py-2 px-6 rounded-md text-primary hover:bg-primary hover:text-white transition-all mt-4 md:mt-0'
                onClick={handleOpen}
            >
                Ajouter Responsable
            </button>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <p className='text-3xl font-bold'>Ajouter Responsable</p>
                    <div className='mt-10'>
                        {/* Full Name */}
                        <div className='mb-4'>
                            <p className='font-medium mb-2'>Nom et prénom</p>
                            <input
                                type='text'
                                placeholder='eg: Nom du responsable'
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={respoName}
                                onChange={e => setRespoName(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                        </div>

                        {/* Email */}
                        <div className='mb-4'>
                            <p className='font-medium mb-2'>E-mail</p>
                            <input
                                type='text'
                                placeholder="eg: responsable@pprime.ma"
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={respoEmail}
                                onChange={e => setRespoEmail(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                        </div>

                        {/* Group ID */}
                        <div className='mb-8'>
                            <p className='font-medium mb-2'>Group ID</p>
                            {/* <select
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={respoGroup}
                                onChange={e => setRespoGroup(e.target.value)}
                            >
                                <option value='' className='text-gray'>Pas maintenant</option>
                                {
                                    groups?.map((group, i) => (
                                        <option key={i} value={group?.value}>{group?.label}</option>
                                    ))
                                }
                            </select> */}

                            <Select
                                options={groups}
                                isSearchable={true}
                                onChange={e => setRespoGroup(e.value)}
                            />
                        </div>

                        {/* Buttons */}
                        <div className='flex justify-end items-center'>
                            <button
                                onClick={handleClose}
                                className='border border-gray rounded-md py-2 px-4 mr-4'
                            >
                                Annuler
                            </button>
                            <button
                                onClick={() => handleAddResponsable()}
                                className='bg-primary text-white rounded-md py-2 px-4'
                            >
                                {
                                    isLoading ? <img src={Loading} alt='' className='w-6' /> : <p>Ajouter</p>
                                }
                            </button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}